import {BasicObject} from '@/types';
import React from 'react';
import {View, StyleSheet} from 'react-native';
import Text from '@/components/basic/text';
import {LazyImageBackground} from '@/components/basic/image';
import theme from '@/style';
import {DIGIT} from '../constant';
import dayjs from 'dayjs';
import {useTranslation} from 'react-i18next';

const DigitResult = ({info = {}}: {info: BasicObject}) => {
  const {i18n} = useTranslation();
  const CodeArr = React.useMemo(() => {
    if (info.wonCode) {
      return info.wonCode.split('');
    }
    return [];
  }, [info.wonCode]);

  return (
    <View
      style={[
        theme.background.white,
        theme.padding.l,
        theme.flex.row,
        theme.flex.centerByCol,
        theme.margin.btml,
      ]}>
      <View>
        <View style={[theme.flex.row, theme.flex.centerByCol]}>
          <Text color={theme.fontColor.accent} size="medium">
            {dayjs(info.gameDrawTime).format('YYYY-MM-DD')}{' '}
          </Text>
          <Text fontFamily="fontInterBold" size="medium">
            {dayjs(info.gameDrawTime).format('hh:mm A')}
          </Text>
        </View>
        <Text fontFamily="fontInterBold" size="medium">
          {i18n.t('bets-detail.label.drawRes')}:
        </Text>
      </View>
      <View
        style={[
          theme.flex.flex1,
          theme.flex.row,
          theme.flex.centerByCol,
          theme.flex.end,
          styles.gap,
        ]}>
        <View style={[theme.flex.row, theme.flex.centerByCol, styles.gap]}>
          {['A', 'B', 'C'].map((item, index) => (
            <LazyImageBackground
              key={index}
              occupancy="transparent"
              style={[theme.flex.center]}
              width={24}
              height={24}
              imageUrl={DIGIT[item]}>
              <Text fontFamily="fontInterBold">{item}</Text>
            </LazyImageBackground>
          ))}
        </View>
        <Text size="medium" fontFamily="fontInterBold">
          =
        </Text>
        <View style={[theme.flex.row, theme.flex.centerByCol, styles.gap]}>
          {['A', 'B', 'C'].map((item, index) => (
            <LazyImageBackground
              key={index}
              occupancy="transparent"
              style={[theme.flex.center]}
              width={24}
              height={24}
              imageUrl={DIGIT[item]}>
              <Text fontFamily="fontInterBold">{CodeArr[index]}</Text>
            </LazyImageBackground>
          ))}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  gap: {
    columnGap: 4,
  },
});

export default DigitResult;
